import React, { Fragment, useEffect, useState } from "react";
import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  Typography,
  Tooltip,
  Chip,
  IconButton,
  CircularProgress,
} from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { ArrowForwardIosRounded } from "@mui/icons-material";
import { useDispatch } from "react-redux";
import { getFileIconImage } from "../../../../../../utils/fileUtils";
import { getFile } from "../../../../../../core/repo/fileRepo";

const useStyles = makeStyles()((theme) => ({
  icon: {
    fontSize: "7px !important",
  },
  card: {
    borderRadius: 12,
    border: `1px solid ${theme.palette.divider}`,
  },
  activeCard: {
    border: `1px solid ${theme.palette.accent}`,
    background: theme.palette.paper,
  },
}));

function AnswerEntity({ source, answer, handleEntityChange = () => {} }) {
  const { classes } = useStyles();
  const { content_object } = answer;
  const entity = content_object["entity"];

  let entityExists = entity && entity["file_id"] && entity["title"];
  const [file, setFile] = useState(null);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (entityExists) {
      const fetchFile = async () => {
        try {
          const file = await dispatch(getFile(entity["file_id"]));
          setFile(file);
        } catch (e) {
          console.log(e);
        } finally {
          setLoading(false);
        }
      };
      fetchFile();
    } else {
      setLoading(false);
    }
  }, [entityExists, entity?.file_id, dispatch]);

  const isSelected = source && source["created_at"] === answer["created_at"];

  return (
    <Fragment>
      {loading ? (
        <Box height={96} display={"flex"} alignItems={"center"}>
          <CircularProgress color="primary" size={24} />
        </Box>
      ) : (
        <Card
          elevation={1}
          onClick={() =>
            entityExists
              ? handleEntityChange({
                  ...entity,
                  created_at: answer["created_at"],
                })
              : null
          }
          className={`${classes.card} ${
            isSelected ? classes.activeCard : null
          }`}>
          <CardActionArea
            sx={{ pointerEvents: entityExists ? "auto" : "none" }}>
            <CardContent
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}>
              <Box
                display={"flex"}
                alignItems={"center"}
                mr={1.5}
                width={"calc(100% - 36px)"}>
                {entityExists && (
                  // <IconButton
                  //   sx={{
                  //     background: " rgba(14, 157, 88, 0.08)",
                  //     marginRight: 1,
                  //   }}>
                  //   <PictureAsPdfRounded sx={{ color: "#E94748" }} />
                  // </IconButton>
                  <img
                    src={getFileIconImage(file["file_type"])}
                    alt={file["name"]}
                    width={24}
                    height={24}
                    style={{ marginRight: 12 }}
                  />
                )}
                <Box width={"calc(100% - 40px)"}>
                  <Typography fontWeight={500} variant="body2">
                    {entityExists
                      ? entity["title"]
                      : "Sorry, could not find the document"}
                  </Typography>
                  <Box mb={1.5} />
                  {file && (
                    <Tooltip title={file["name"]}>
                      <Chip
                        label={
                          <Typography variant="caption" noWrap>
                            {file["name"]}
                          </Typography>
                        }
                        size="small"
                        icon={
                          <img
                            src={getFileIconImage(file["file_type"])}
                            alt={file["name"]}
                            width={16}
                            height={16}
                          />
                        }
                      />
                    </Tooltip>
                  )}
                </Box>
              </Box>
              {entityExists && (
                <IconButton size="small">
                  <ArrowForwardIosRounded fontSize="small" />
                </IconButton>
              )}
            </CardContent>
          </CardActionArea>
        </Card>
      )}
    </Fragment>
  );
}

export default AnswerEntity;
